/**
 * Device service – kebutuhan report device ke server dipetakan ke repository.
 */

import { appendLog } from '../../logStore.js';
import * as repo from '../repository.js';
/**
 * Default URL untuk device report.
 * Kosong by default: endpoint report harus datang dari `control.device.reportUrl`.
 */
export const DEFAULT_REPORT_URL = '';

/**
 * Kirim data device ke server (POST).
 * @param {string} url – endpoint report (biasanya dari control.device.reportUrl)
 * @param {object} payload – body JSON (device info + optional extra)
 * @returns {Promise<{ ok: boolean, error?: string }>}
 */
export async function reportDevice(url, payload) {
  if (!url) return { ok: false, error: 'no-url' };
  const result = await repo.postDeviceReport(url, payload);
  try {
    appendLog({
      type: result.ok ? 'info' : 'warn',
      detail: { event: 'device-report', status: result.ok ? 'ok' : 'fail', url },
    });
  } catch {}
  if (!result.ok && result.error) {
    try {
      appendLog({
        type: 'error',
        detail: { event: 'device-report-failed', message: result.error },
      });
    } catch {}
  }
  return result;
}
